import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledConversationMessagesSkeletonContainer = styled(Flexbox)(
    () => css`
        min-height: 100%;
    `
)

export const StyledMessageBubbleSkeleton = styled.div<{$isOwnMessage: boolean}>(
    ({$isOwnMessage, theme: {spacing, palette, borderRadius}}) => css`
        padding: ${spacing * 2}px ${spacing * 3}px;
        background-color: ${palette.neutral[100]};
        border-right-color: ${palette.neutral[100]};
        border-radius: ${borderRadius * 2}px;
        position: relative;
        opacity: 0.7;

        /* Chat bubble tail */
        &::after {
            content: '';
            position: absolute;
            top: 0;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            ${$isOwnMessage
                ? css`
                      right: -8px;
                      border-right: 0;
                      opacity: 0.7;
                  `
                : css`
                      left: -8px;
                      border-left: 0;
                      opacity: 0.7;
                  `}
        }
    `
)

export const StyledMessageBubbleContent = styled(Flexbox)(
    () => css`
        min-width: 120px;
    `
)
